import { useNavigate } from 'react-router-dom';
import AppShell from '../components/AppShell';
import PrimaryButton from '../components/PrimaryButton';

function HomePage() {
  const navigate = useNavigate();

  return (
    <AppShell>
      <section className="hero">
        <div className="hero-badge">CryptoFog Network</div>
        <h1>Игровой майнинг HASH с ежедневными наградами</h1>
        <p>
          Запускай майнинг, выполняй задания, забирай бонусы и приглашай друзей.
        </p>
        <div className="hero-actions">
          <PrimaryButton onClick={() => navigate('/download')}>Скачать приложение</PrimaryButton>
        </div>
      </section>

      <section className="feature-grid" id="features">
        <FeatureCard title="Майнинг" text="Активируй добычу после рекламы и продлевай таймер сколько нужно." />
        <FeatureCard title="Задания" text="Еженедельные цели дают дополнительные H-Coins за активность." />
        <FeatureCard title="Лидерборд" text="Соревнуйся с другими майнерами и отслеживай своё место." />
        <FeatureCard title="Рефералы" text="Приглашай друзей и получай процент от их начислений." />
      </section>
    </AppShell>
  );
}

function FeatureCard({ title, text }) {
  return (
    <article className="feature-card">
      <div className="feature-dot" />
      <h3>{title}</h3>
      <p>{text}</p>
    </article>
  );
}

export default HomePage;
